import { ActionCommandResponseDto } from "@app/core/dto/action-command-response.dto";
import { ActionCommand } from "../action-command-interface";
import { RequestDataDto } from "@app/core/dto/request-data.dto";
import { SearchPayloadDto, SearchRequestDto } from "@app/core/dto/abstract-action.dto";

export class AutosuggestCommand implements ActionCommand {
  constructor(private renderEngineComponent: any) { }

  async execute(actionData: any, requestData: RequestDataDto): Promise<ActionCommandResponseDto> {
    const formattedAction: SearchRequestDto = new SearchRequestDto();
    formattedAction.action = actionData?.type;

    const payload = { ...actionData?.params };
    formattedAction.payload = new SearchPayloadDto(payload);
    requestData.updatedAction = { ...formattedAction };
    this.autoSuggestData(requestData?.updatedAction?.payload);
    return;
  }

  private autoSuggestData(data: any): void {
    this.renderEngineComponent.httpClient.post('/api/search/autosuggest/', data).subscribe({
      next: (res: any) =>
        this.handleSuggestionsData({
          ...res.RESPONSE.suggestions,
          slots: res.RESPONSE.suggestions,
        }),
      error: (err) => console.log(err),
      complete: () => { },
    });
  }

  private handleSuggestionsData(suggestions: any): void {
    this.renderEngineComponent.suggestions.set(suggestions);
  }
}